export default {
  'verification.welcome.title': 'Welcome to Knit',
  'verification.welcome.subtitle':
    'Please enter your invite code to start your AI journey',
  'verification.input.label': 'Enter invite code',
  'verification.submit.loading': 'Submitting...',
  'verification.hint.terms':
    'By entering the invite code, you agree to our Terms of Service and Privacy Policy.',
  'verification.message.success': 'Verification successful!',
  'verification.message.error': 'Invite code error',
  'verification.message.incomplete': 'Please enter complete invite code',

  // Login messages
  'verification.invalidEmail': 'Please enter a valid email address',
  'verification.codeSent': 'Verification code has been sent to your email',
  'verification.sendCodeFailed':
    'Failed to send verification code, please try again',
  'verification.invalidCredentials': 'Invalid username or password',
  'verification.loginFailed': 'Login failed, please try again',
  'verification.googleLoginInvalidResponse':
    'Google login failed: invalid response',
  'verification.googleLoginProcessError':
    'Google login failed: processing error',
  'verification.enterUsernameAndPassword': 'Please enter username and password',
  'verification.loginSuccessEnteringWorld':
    'Login successful, entering the world...',
  'verification.registerInDevelopment':
    'Registration feature is under development...',
  'verification.guestModeComingSoon': 'Guest mode coming soon...',
};
